import axios from "axios";

const axiosFetch = axios.create({
  baseURL: `${process.env.REACT_APP_V5_BASE_URL || ""}/mondia`,
});

function modelGetSubscriptionTypes(data) {
  return (data?.data?.data || []).map((item) => ({
    id: item.id,
    name: item?.name || "",
    duration: item?.duration_label || "",
    price: item?.price || "",
    currency: item?.currency || item?.currency_text || "",
    tax: item?.tax || 0
  }));
}

function modelGetSubscriptionType(data) {
  const payload = data?.data?.data || {}
  return {
    id: payload.id,
    name: payload?.name || "",
    duration: payload?.duration_label || "",
    price: payload?.price || "",
    currency: payload?.currency || payload?.currency_text || "",
    tax: payload?.tax || 0
  };
}

export async function getSubscriptionTypes(payload, lang='ar') {
  try {
    const data = await axiosFetch.post("/get-subscription-type", {
      ...payload,
    },
    {
      headers:{
        'accept-language': lang
      },
    }
  );

    if (payload.id) {
      return modelGetSubscriptionType(data);
    }

    return modelGetSubscriptionTypes(data);
  } catch (e) {
    throw new Error(e);
  }
}
